import React, { useEffect } from "react";
import { useColumnSize } from "shared/hooks/use-column-size";

export const ProductHeader = ({ col, onColumnWidthChange, lastCol, resizerEnabled, ...props }) => {
    const { colRef, resizerRef, width, initialize } = useColumnSize();
    const { img, upc, name, description, age } = props.product;
    const imgTag = img ? (
        <img
            src={img}
            alt={name}
        />
    ) : (
        ""
    );
    const displayAge = age === "Current WIP" ? age : `${age} Days Ago`;

    useEffect(() => {
        if (width !== 0) {
            onColumnWidthChange(col, width);
        }
    }, [width]);

    return (
        <div
            ref={!lastCol && resizerEnabled ? colRef : null}
            onMouseDown={!lastCol && resizerEnabled ? initialize : null}
        >
            {resizerEnabled && (
                <div
                    ref={resizerRef}
                    className="border-resizer"
                />
            )}
            {imgTag}
            <p>{upc}</p>
            <p>{name || description}</p>
            <p>{displayAge}</p>
        </div>
    );
};
